module.exports = __webpack_public_path__ + "img/8@2x.6ed93820.png";